import styled from "styled-components";
import { cPlaceholder } from "../../styles/global";
import FixedAspect from "../FixedAspect";
import Img from "../Img";

export const Placeholder = styled(FixedAspect)`
  position: relative;
  ${"" /* background: ${cPlaceholder}; */}

  > div {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Image = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  transition: opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;
